import script from "./CrowdfundingPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CrowdfundingPayment.vue?vue&type=script&setup=true&lang=js"

import "./CrowdfundingPayment.vue?vue&type=style&index=0&id=ba833476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba833476"]])

export default __exports__